import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import './ProfilePage.css';

export function ProfilePage() {
  const navigate = useNavigate();
  const { user, updateTheme, logout } = useAuthStore();
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  useEffect(() => {
    if (user) {
      setTheme(user.theme);
    }
  }, [user]);

  const handleThemeChange = async (newTheme: 'light' | 'dark') => {
    setTheme(newTheme);
    await updateTheme(newTheme);
  };

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  if (!user) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="profile-page">
      <div className="page-header">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Назад
        </button>
        <h1>Профиль</h1>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h2>Информация</h2>
          <div className="profile-info">
            <div className="info-item">
              <span className="info-label">Telegram ID:</span>
              <span className="info-value">{user.telegramId}</span>
            </div>
            {user.username && (
              <div className="info-item">
                <span className="info-label">Username:</span>
                <span className="info-value">@{user.username}</span>
              </div>
            )}
            {user.firstName && (
              <div className="info-item">
                <span className="info-label">Имя:</span>
                <span className="info-value">{user.firstName}</span>
              </div>
            )}
            {user.lastName && (
              <div className="info-item">
                <span className="info-label">Фамилия:</span>
                <span className="info-value">{user.lastName}</span>
              </div>
            )}
          </div>
        </div>

        <div className="profile-section">
          <h2>Настройки</h2>
          <div className="settings">
            <div className="setting-item">
              <span className="setting-label">Тема:</span>
              <div className="theme-buttons">
                <button
                  className={theme === 'light' ? 'active' : ''}
                  onClick={() => handleThemeChange('light')}
                >
                  Светлая
                </button>
                <button
                  className={theme === 'dark' ? 'active' : ''}
                  onClick={() => handleThemeChange('dark')}
                >
                  Тёмная
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-actions">
          <button className="logout-button" onClick={handleLogout}>
            Выйти
          </button>
        </div>
      </div>
    </div>
  );
}

